export const METRICS_PAGE_ID = 'board-settings-apps.card-colors-page';

export const BOARD_SETTINGS_ARTICLE_ID_CARD_COLORS_JSW = '10DTPAc0QDeqKK20lm2qK9';
export const BOARD_SETTINGS_ARTICLE_ID_CARD_COLORS_JSM = '4NHFgGDm9LmUapYPn3da7g';
export const BOARD_SETTINGS_ARTICLE_ID_CARD_COLORS_JSW_ANALYTICS_ID = `${METRICS_PAGE_ID}.cmp.article.analytics`;

export const CARD_COLOR_STRATEGY_FIELD_WIDTH = 232;
